"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonWrapper = exports.StyledTitleSection = exports.TableTitle = void 0;
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const styles_1 = require("@mui/material/styles");
exports.TableTitle = (0, styles_1.styled)(Typography_1.default)(({ theme }) => ({
    color: theme.palette.institutional.braskemGray,
}));
exports.StyledTitleSection = (0, styles_1.styled)("div")(({ theme }) => ({
    display: "flex",
    width: "100%",
    alignItems: "center",
    marginBottom: theme.spacing(4),
}));
exports.ButtonWrapper = (0, styles_1.styled)("div")({
    marginLeft: "1.4rem",
});
